<script lang="ts" setup>
import { watch } from 'vue';

import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';
import usePromise from '@exchange/libs/composables/shared/src/lib/usePromise';

import useLogInOut from '../../useLogInOut';

const emit = defineEmits<{
  (event: 'doing-logout', value: boolean): void;
}>();

const { isXS } = useMQBreakpoints();
const { refElem, logout } = useLogInOut();
const { loading: doingLogout, createPromise: logoutNow } = usePromise(logout);

const authLogout = () => logoutNow(isXS.value);

watch(
  doingLogout,
  () => {
    emit('doing-logout', doingLogout.value);
  },
  { immediate: true },
);
</script>

<template>
  <div
    ref="refElem"
    class="auth-logout"
    @click="authLogout"
  >
    {{ $t('modules.auth.logout') }}
  </div>
</template>

<style lang="scss">
.auth-logout {
  font-size: var(--font-size-sm);
  text-decoration: underline;
}
</style>
